const Road = ({ className = "", color }: { className?: string; color: string }) => (
  <svg
    className={className}
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 64 64"
    role="img"
    xmlnsXlink="http://www.w3.org/1999/xlink"
  >
    <path
      data-name="layer2"
      d="M52.062 2C32.078 2 24 14.162 24 20c0 7.131 4 6.094 4 12 0 8.23-24 20-24 20l44 10s10-3.866 10-18c0-15.761-14-18.869-14-26 0-5.754 6.5-10 14-10z"
      fill={color}
    ></path>
    <path
      data-name="layer1"
      d="M41.667 10.678a1 1 0 0 1-.473-1.878q.669-.357 1.37-.7a1 1 0 0 1 .871 1.8q-.663.321-1.3.659a1 1 0 0 1-.468.119zm-7.22 44.012a1 1 0 0 1-.626-1.78 30.813 30.813 0 0 0 1.779-1.538 1 1 0 0 1 1.367 1.461c-.584.546-1.222 1.1-1.9 1.638a1 1 0 0 1-.62.219zm5.609-6.149a1 1 0 0 1-.856-1.511 13.044 13.044 0 0 0 1.428-3.356 1 1 0 1 1 1.935.506 15.035 15.035 0 0 1-1.644 3.872 1 1 0 0 1-.863.489zm1.717-9.159a1 1 0 0 1-.983-.82 15.12 15.12 0 0 0-.7-2.522 1 1 0 0 1 1.875-.7 17.113 17.113 0 0 1 .793 2.858 1 1 0 0 1-.8 1.163.946.946 0 0 1-.185.021zM38 31.133a1 1 0 0 1-.817-.422 37.82 37.82 0 0 1-1.818-2.81 1 1 0 0 1 1.729-1c.494.85 1.073 1.744 1.72 2.658A1 1 0 0 1 38 31.133zm-3.921-7.753a1 1 0 0 1-.969-.756 11.553 11.553 0 0 1-.369-3.283.989.989 0 0 1 1.041-.958 1 1 0 0 1 .957 1.04 9.57 9.57 0 0 0 .31 2.713 1 1 0 0 1-.971 1.244zm1.68-8.014A1 1 0 0 1 35 13.718a14.021 14.021 0 0 1 2.545-2.292 1 1 0 0 1 1.166 1.625 12.1 12.1 0 0 0-2.189 1.964 1 1 0 0 1-.763.351z"
      fill="#e8e8e8"
    ></path>
  </svg>
);

export default Road;
